import { render, staticRenderFns } from "./counsel-report-card.vue?vue&type=template&id=3fee3286&scoped=true&"
import script from "./counsel-report-card.vue?vue&type=script&lang=js&"
export * from "./counsel-report-card.vue?vue&type=script&lang=js&"
import style0 from "./counsel-report-card.vue?vue&type=style&index=0&id=3fee3286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee3286",
  null
  
)

export default component.exports